import { type FC } from "react";

import { LensListPageHeight } from "./LensesPage.styles";
import { LensesList } from "./list";

export const LensesPageTabs: FC = () => {
    return (
        <LensListPageHeight>
            <LensesList />
        </LensListPageHeight>
    );
};
